import { useState, type ChangeEvent } from 'react'

type PasswordFieldProps = {
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  autoComplete?: string
  error?: string
  required?: boolean
  variant?: 'auth' | 'admin'
}

function EyeOpenIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M2 12s3.5-7.25 10-7.25S22 12 22 12s-3.5 7.25-10 7.25S2 12 2 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  )
}

function EyeClosedIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M3 3l18 18" />
      <path d="M10.58 10.58A2 2 0 0 0 12 15a2 2 0 0 0 1.42-.58" />
      <path d="M9.88 5.09A10.42 10.42 0 0 1 12 4.75c5.5 0 9 5.25 9 7.25a13.33 13.33 0 0 1-3.03 4.05" />
      <path d="M6.1 6.1A13.43 13.43 0 0 0 3 12c0 2 3.5 7.25 9 7.25a11.73 11.73 0 0 0 3.06-.42" />
      <path d="M14.12 9.88A2 2 0 0 0 12 8.75" />
    </svg>
  )
}

export function PasswordField({
  label,
  value,
  onChange,
  placeholder,
  autoComplete = 'current-password',
  error,
  required = false,
  variant = 'auth',
}: PasswordFieldProps) {
  const [visible, setVisible] = useState(false)
  const wrapperClassName = `${variant}-password-field`
  const toggleClassName = `${variant}-password-toggle`

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value)
  }

  return (
    <label>
      <span>{label}</span>
      <div className={wrapperClassName}>
        <input
          type={visible ? 'text' : 'password'}
          autoComplete={autoComplete}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          required={required}
        />
        <button
          type="button"
          className={toggleClassName}
          onClick={() => setVisible((current) => !current)}
          aria-pressed={visible}
          aria-label={visible ? 'Ocultar senha' : 'Ver senha'}
        >
          {visible ? <EyeClosedIcon /> : <EyeOpenIcon />}
        </button>
      </div>
      {error ? <small>{error}</small> : null}
    </label>
  )
}
